import React from 'react';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import noImageBoilerplateUrl from '../../../../resources/img/noImageBoilerplateUrl.png';
import pen from '../../../../resources/img/pen.png';
import styles from './article-item.module.scss';

export default class ArticleItem extends React.PureComponent{
  render() {
    const { title, image_url, author, publisher, created_at, id, read_mins, fisk_count } = this.props;
    const imageStyling = { width: '140px', height: '84px', objectFit: 'cover' };

    return (
      <Link style={{ textDecoration: 'none' }}to={`/article/${id}/discuss`}>
        <div className={styles.fiskItemContainer}>
          <div className={styles.fiskItemImageContainer}>
            <object
              // if <object> fails to load, it will fallback on inner tag
              // if image_url is falsey, then noImageBoilerplateUrl will be used instead
              alt={title}
              style={imageStyling}
              data={image_url ? image_url : noImageBoilerplateUrl}
              type="image/png">
                <img
                  src={noImageBoilerplateUrl}
                  alt={title}
                  style={imageStyling}
                />
            </object>
          </div>
          <div className={styles.fiskItemCaptionContainer}>

            <h2 className={styles.fiskLink}>{title}</h2>

            <div>
              <span className={styles.fiskLine + " - " + styles.additional}>{author ? author : 'Author'} | </span>
              <span className={styles.fiskLine + " - " + styles.additional}>
                {publisher ? publisher : 'Publisher'} |
              </span>
              <span className={styles.fiskLine + " - " + styles.additional}>
                <Moment format=" MMMM DD, YYYY">
                  {created_at}
                </Moment>
                {read_mins ? 
                <React.Fragment>
                  <span> | </span>
                  <span className={styles.fiskLine + " - " + styles.additional}>
                    {read_mins ? read_mins + ' minutes' : ''}
                  </span> 
                </React.Fragment>
                : null}
                <span> | </span>
                <span><img className={styles.fiskPen} src={pen} alt="pen icon" /></span>
                <span className={styles.fiskLine + " - " + styles.additional}>{fisk_count}</span>
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}
